//include 8
jQuery(function(){
    
    var checkAll = function (elements) {
        elements.each(function () {
            var $this = $(this);
            var checkAll = $this.data("checkbox-checkall");
            if (!checkAll)
                return;
            $this.on('change', function () {
                var state = $this.is(":checked");
                $(`[data-checkbox-checkall='${checkAll}']`).prop('checked', state);
            });
        });
    }

    window.ppComponents = window.ppComponents || {};
    window.ppComponents.common = window.ppComponents.common || {};
    window.ppComponents.common.checkAll = checkAll;

    checkAll($('[data-checkbox-checkall]'));
});